import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndoorTeamsBootstrapComponent } from './indoor-teams-bootstrap/indoor-teams-bootstrap.component';

const routes: Routes = [
  { path: '', component: IndoorTeamsBootstrapComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndoorWorldSeriesTeamsRoutingModule {}
